import React, { useState } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";
import PropTypes from "prop-types";

import { isValidEmail } from "../../../utils";
import { TextField } from "../../atoms/textfield";
import { Checkbox } from "../../atoms/checkbox";
import { subscribeToMailchimp } from "./api.js";

import LoadingIcon from "../../../../assets/images/loader.svg";
import NewsLetterConfig from "../../../../../config/newsletter";
import "./newsletter.m.css";

const NewsletterPageBase = ({ config, currentPath }) => {
  const domainSlug = config.domainSlug;
  const {
    title,
    description,
    subscriptionData,
    hindiTitle,
    hindiDescription
  } = NewsLetterConfig();
  const [email, setEmail] = useState();
  const [error, setError] = useState();
  const [subscribeMailStatus, setSubscribeMailStatus] = useState([]);
  const [selectOptionStatus, setSelectOptionStatus] = useState();
  const [showLoader, setShowLoader] = useState();
  const setSubscriptionData = domainSlug
    ? subscriptionData.filter(item => item.title === "न्यूज़लॉन्ड्री डाक")
    : subscriptionData;
  const publisher = get(config, ["publisher", "publisher"], {});
  const splitUrl = currentPath.split("?");
  const getPlan =
    (splitUrl && splitUrl.length >= 1 && decodeURIComponent(splitUrl[1])) ||
    null;
  const getPlanDetails =
    subscriptionData.filter(item => item.title == getPlan) || [];
  const planName = (getPlanDetails.length > 0 && getPlanDetails[0].id) || null;
  const getPlanObject = planName
    ? {
        [planName]: true,
        [`${planName}value`]: getPlanDetails[0].title,
        [`${planName}list`]: getPlanDetails[0].mailChimplistId
      }
    : {};

  const [checkedItems, setCheckedItems] = useState(getPlanObject);

  const onChange = e => {
    setEmail(e.target.value);

    e.target.value ? setError("") : setError("Please provide Email !!");
  };

  const handleChange = event => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
      [`${event.target.name}value`]: event.target.value,
      [`${event.target.name}list`]: event.target.id
    });
  };

  const arrayValue = [
    checkedItems.first === true ? checkedItems.firstvalue : "",
    checkedItems.second === true ? checkedItems.secondvalue : "",
    checkedItems.third === true ? checkedItems.thirdvalue : "",
    checkedItems.fourth === true ? checkedItems.fourthvalue : "",
    checkedItems.fifth === true ? checkedItems.fifthvalue : "",
    checkedItems.sixth === true ? checkedItems.sixthvalue : ""
  ].filter(item => item !== "");

  const onSubmitClick = () => {
    if (email) {
      if (!isValidEmail(email)) {
        setError("Invalid Email !!");
      } else if (arrayValue.length > 0) {
        setShowLoader(true);
        subscribeToMailchimp({
          email: email,
          listId1: checkedItems.first === true ? checkedItems.firstlist : "",
          listId2: checkedItems.second === true ? checkedItems.secondlist : "",
          listId3: checkedItems.third === true ? checkedItems.thirdlist : "",
          listId4: checkedItems.fourth === true ? checkedItems.fourthlist : "",
          listId5: checkedItems.fifth === true ? checkedItems.fifthlist : "",
          listId6: checkedItems.sixth === true ? checkedItems.sixthlist : ""
        })
          .then(status => {
            setSubscribeMailStatus(status);
            setEmail("");
            setTimeout(function() {
              setSubscribeMailStatus([]);
              setCheckedItems([]);
            }, 6000);
            if (status.length > 0) {
              setShowLoader(false);
            }
          })
          .catch(() => {
            setSubscribeMailStatus([]);
          });
      } else {
        setSelectOptionStatus("please select the options...");
      }
    } else {
      setError("Please provide Email !!");
      setSubscribeMailStatus([]);
    }
  };

  return (
    <div className="full-width-with-padding" styleName="container">
      <div styleName="wrapper">
        {title && !domainSlug ? (
          <h1 styleName="main-headline">{title}</h1>
        ) : (
          <h1 styleName="main-headline">{hindiTitle}</h1>
        )}
        {description && !domainSlug ? (
          <p styleName="main-description">{description}</p>
        ) : (
          <p styleName="main-description">{hindiDescription}</p>
        )}
        <div styleName="plan-grid">
          {setSubscriptionData.length > 0 &&
            setSubscriptionData.map((plan, index) => {
              return (
                <div
                  key={index}
                  styleName={`plan-wrapper ${
                    checkedItems[`${plan.id}`] === true
                      ? "plan-wrapper-active"
                      : ""
                  }`}
                >
                  <div styleName="checkbox-wrapper">
                    <Checkbox
                      id={plan.mailChimplistId}
                      value={plan.title}
                      name={plan.id}
                      checked={checkedItems[`${plan.id}`]}
                      onChange={handleChange}
                    />
                    <span styleName="checkmark"> </span>
                  </div>
                  <div styleName="headine-wrapper">
                    <h4 styleName="headline">{plan.title}</h4>
                  </div>
                  <div styleName="description"> {plan.description}</div>
                  {checkedItems[`${plan.id}`] === true &&
                    subscribeMailStatus[index] &&
                    subscribeMailStatus[index].status === "subscribed" && (
                      <div styleName="message">
                        {subscribeMailStatus[index].status}
                      </div>
                    )}
                  {checkedItems[`${plan.id}`] === true &&
                    subscribeMailStatus[index] &&
                    subscribeMailStatus[index].status === 400 && (
                      <div styleName="message">
                        {subscribeMailStatus[index].title}
                      </div>
                    )}
                </div>
              );
            })}
        </div>
        {arrayValue.length > 0 ? (
          <div styleName="subscribe-option">
            Subscribe to{" "}
            {arrayValue.map((item, index) => {
              return (
                <span key={index}>{(index ? ", " : "") + item.trim()}</span>
              );
            })}{" "}
            by giving your email id{" "}
          </div>
        ) : null}
        {showLoader === true && (
          <div styleName="modal">
            <div styleName="modal-content">
              <img src={assetify(LoadingIcon)} alt="loading" />
            </div>
          </div>
        )}
        <div styleName="subscribe-view-content">
          <TextField
            value={email}
            error={error}
            onChange={onChange}
            placeholder="Type your email"
          />
          <button styleName="submit-btn" onClick={onSubmitClick}>
            Sign Up
          </button>
        </div>
        {/* {subscribeMailStatus && subscribeMailStatus.length > 0 && <div styleName="message">Thank You !!!</div>} */}
        {subscribeMailStatus && subscribeMailStatus.length > 0 && (
          <div styleName="modal">
            <div styleName="modal-content show-message">
              Thanks for signing up. See you in your inbox soon.
            </div>
          </div>
        )}
        {selectOptionStatus && arrayValue.length < 1 && (
          <div styleName="message">{selectOptionStatus}</div>
        )}
      </div>
    </div>
  );
};

NewsletterPageBase.propTypes = {
  config: PropTypes.object
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"], {}),
  currentPath: get(state, ["qt", "currentPath"], "")
});

export const NewsletterPage = connect(mapStateToProps)(NewsletterPageBase);
